import { render, staticRenderFns } from "./support-category.vue?vue&type=template&id=c2b00c12&"
import script from "./support-category.vue?vue&type=script&lang=js&"
export * from "./support-category.vue?vue&type=script&lang=js&"
import style0 from "./support-category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SupportArticle: require('/opt/build/repo/storefront/components/legacy/support/support-article.vue').default})
